// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Items_wrapper__Be3gm","description":"Items_description__Iu83z","image":"Items_image___j0eG"};